import { useMutation, useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { queryClient } from '../store/provider/TanStackProvider'
import { HistoryResMock, SocialDataMock } from '../types/history.type'
import { FamilyProps } from './useFamily'

export const useSocial = (arg?: FamilyProps) => {
  const patientId = arg?.patientId
  const intakeId = arg?.intakeId
  const sortDir = arg?.sortDir || 'desc'

  const { data: socials, isLoading } = useQuery({
    queryFn: async () => {
      let endpoint = `/social_histories?`
      if (intakeId) endpoint += `intake_id=${intakeId}&`
      if (patientId) endpoint += `patient_id=${patientId}&`
      if (sortDir) endpoint += `sort_dir=${sortDir}&`
      const { data } = await AXIOS_INSTANCE.get<HistoryResMock<SocialDataMock[]>>(endpoint)
      return data.data
    },
    queryKey: ['social', { intakeId, patientId }]
  })

  const { mutateAsync: createSocial } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post(`/social_histories`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['social', {}] })
  })

  const { mutateAsync: updateSocial } = useMutation({
    mutationFn: async ({ data, id }: { data: any; id: string }) => {
      await AXIOS_INSTANCE.patch(`social_histories/${id}`, data, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['social'] })
      queryClient.invalidateQueries({ queryKey: ['social', { patientId }] })
    }
  })
  return { createSocial, isLoading, socials, updateSocial }
}
